module.exports = __webpack_public_path__ + "assets/img/2-0.2cb2b473.svg";